import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as router from '@attain-apps/fe/web/main/lib/router'

import * as me from '../../../me'
import * as routeBound from '../../../route-bound'

import { Api, DETAIL_TEXT } from './api.service'
import * as effects from './effects'
import * as plugins from './plugins'
import type { TypeParams } from './types'

/**
 * Space record collection that should actually only work with getRecord, and
 * updateRecord. List is being done through mosaic dms query, since the records
 * list page was done through mosaic.
 */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  /** @see {@link router.Router} */
  private readonly _router = ngCore.inject(router.Router)
  /** @see {@link me.Feature} */
  private readonly _meFeature = ngCore.inject(me.Feature)

  constructor() {
    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: record => record.id,
      name: ec.Name.Predefined.SpaceRecordLite,
      plugins: {
        additionalFactories: [
          new plugins.functionalUsage.Factory(),
          new plugins.organizationDimensionFilter.Factory(),
          new plugins.roomTypeDimensionFilter.Factory(),
          new plugins.surveyStatus.Factory(),
          new plugins.spaceDimensionFilter.Factory(),
          new ds.table.ec.Factory<TypeParams>(collection => ({
            columnConfigs: {
              occupier: {
                cellConfig: ({ value }) => ({
                  css: {
                    fontStyle: value === DETAIL_TEXT ? 'italic' : 'normal',
                  },
                }),
              },
            },
            rowConfig: ({ entity, rowIdx }) => ({
              onClick: () => {
                const source = `Records.Table.Row-${rowIdx}.Clicked`

                this.plugins.currentEntityPlugin.storage.actions.putInIdLookup
                  .from(source)
                  .dispatch({
                    value: entity.id,
                  })

                const url = this._meFeature.contexts.selectors
                  .getUrlForLink({
                    goto: {
                      navigationId:
                        ents.extra.prebuilt.Page.Id.SpaceLiteRecordDetails,
                    },
                  })
                  .asSignal()

                if (url) {
                  this._router.actions.navigate.from(source).dispatch({ url })
                }
              },
            }),
          })),
        ],
        currentList: {
          quantity: {
            get: quantity => quantity ?? 20,
          },
        },
        dataOperation: {
          useCacheInsteadOfApi: false,
        },
      },
    })
    this.feature.registerEffects(
      effects.reloadOnOrgAssignmentChange(this),
      effects.reloadOnRecordUpdate(this),
    )
  }
}
